import { createContext } from 'react';

import { WorkflowTracker } from '@/types/schema';

export interface CurrentUserWorkflowTrackersContextValue {
  trackers: WorkflowTracker[];
  byId: Record<string, WorkflowTracker>;
  refetch: () => Promise<unknown>;
  loadOlder: () => Promise<void>;
  dismissAll: () => Promise<void>;
  hasMore: boolean;
  loading: boolean;
  loadingMore: boolean;
}

/**
 * Context for subscribing to WorkflowTrackers that should be shown in the activities sidebar.
 * This is specifically for current user workflow trackers that need UI interaction capabilities
 * like pagination, dismissal, and loading states.
 */
export const CurrentUserWorkflowTrackersContext = createContext<
  CurrentUserWorkflowTrackersContextValue | undefined
>(undefined);
